// app/javascript/controllers/task_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["contactSelect", "supporterSelect", "locationSelect"]

  connect() {
    // Suche das Customer-Select (außerhalb der targets, da es das Event auslöst)
    const customerSelect = this.element.querySelector('#floatingCust')
    if (customerSelect && customerSelect.value) {
      this.fetchDependentData(customerSelect.value, true)
    }
  }

  customerChanged(event) {
    this.fetchDependentData(event.target.value, false)
  }

  fetchDependentData(customerId, isInitialLoad) {
    if (!customerId) {
      this.clearSelects()
      return
    }

    fetch(`/customers/${customerId}/dependent_data`, {
      headers: { "Accept": "application/json" }
    })
      .then(response => response.json())
      .then(data => {
        // Wir merken uns die IDs, die aktuell im HTML stehen (vom Server gerendert)
        const currentContactId = this.contactSelectTarget.value
        const currentSupporterId = this.supporterSelectTarget.value
        const currentLocationId = this.locationSelectTarget.value

        this.updateSelect(this.contactSelectTarget, data.contacts, currentContactId)
        this.updateSelect(this.supporterSelectTarget, data.supporters, currentSupporterId)
        this.updateSelect(this.locationSelectTarget, data.locations, currentLocationId)
      })
  }

  updateSelect(selectElement, options, selectedValue) {
    const firstOption = selectElement.options[0]
    selectElement.innerHTML = ""
    if (firstOption) selectElement.appendChild(firstOption)

    options.forEach(option => {
      const opt = document.createElement("option")
      opt.value = option.id
      opt.textContent = option.name
      // WICHTIG: Setze 'selected', wenn die ID übereinstimmt
      if (selectedValue && option.id.toString() === selectedValue.toString()) {
        opt.selected = true
      }
      selectElement.appendChild(opt)
    })
    selectElement.disabled = options.length === 0;
  }

  clearSelects() {
    this.contactSelectTarget.disabled = true;
    this.supporterSelectTarget.disabled = true;
    this.locationSelectTarget.disabled = true;
    [this.contactSelectTarget, this.supporterSelectTarget, this.locationSelectTarget].forEach(select => {
      const first = select.options[0]
      select.innerHTML = ""
      if (first) select.appendChild(first)
    })
  }
}